<template>
  <div v-if="page + 1 < totalPage"
       class="next-page__button q-col-12 q-d-block q-d-md-none q-pb-3 q-px-2">
    <button type="button"
            class="q-btn q-btn q-btn-danger q-rounded-3 q-shadow-sm q-w-100"
            @click="paginationStore.setActualPageValue(getNextPage)"
    >
      <span>{{ nextPageButtonText }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {storeToRefs} from "pinia";
import {defineProps, inject} from "vue";
import {SmartSearchTranslationsInterface} from "@/core/types";


defineProps(['position'])
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

let {nextPageButtonText} = SmartSearchTranslations.value.pagination

const paginationStore = usePaginationStore();

const {totalPage, page, getNextPage} = storeToRefs(paginationStore)
</script>


